import {Form, Input, Switch, Row, Col, InputNumber} from "antd";
import React from "react";
import {usePermissions} from "react-admin";

const HTTPRequestForm = (props: any) => {
    const { permissions } = usePermissions();
    return (
        <>
            <Form.Item label="Target URL" name="target_url" rules={[{ required: true, message: 'Please enter Target URL' }]}>
                <Input placeholder="https://example.com/netorca" disabled={permissions !== "ADMIN"} />
            </Form.Item>

            <Form.Item label="Authorization" name="authorization" rules={[{ required: false, message: 'authorization header' }]}>
                <Input placeholder="Authorization" disabled={permissions !== "ADMIN"} />
            </Form.Item>

            <Row gutter={16}>
                <Col span={10}>
                    <Form.Item label="SSL Verification" name="verify" rules={[{ required: true }]} valuePropName="checked" labelCol={{ span: 10 }}>
                        <Switch disabled={permissions !== "ADMIN"} />
                    </Form.Item>
                </Col>
                <Col span={10}>
                    <Form.Item label="Timeout" name="timeout" rules={[{ required: true }]} >
                        <InputNumber placeholder="seconds" min={1} max={300} disabled={permissions !== "ADMIN"} />
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}


export default HTTPRequestForm;